import { Modal, Form, Input, Checkbox, App } from 'antd';
import { useCreateTerm } from '@/hooks/useGlossary';

interface Props {
  open: boolean;
  onClose: () => void;
}

export function AddTermModal({ open, onClose }: Props) {
  const { message } = App.useApp();
  const [form] = Form.useForm<{ term: string; preserve_as_is: boolean; notes?: string }>();
  const mut = useCreateTerm();

  async function submit() {
    const vals = await form.validateFields();
    try {
      await mut.mutateAsync({
        term: vals.term.trim(),
        preserve_as_is: vals.preserve_as_is,
        notes: vals.notes?.trim() || null,
      });
      message.success('Term added');
      form.resetFields();
      onClose();
    } catch (e) {
      message.error((e as Error).message);
    }
  }

  return (
    <Modal
      open={open}
      title="Add glossary term"
      onCancel={onClose}
      onOk={submit}
      confirmLoading={mut.isPending}
      destroyOnHidden
    >
      <Form form={form} layout="vertical" initialValues={{ preserve_as_is: false }}>
        <Form.Item label="Source term (English)" name="term" rules={[{ required: true }]}>
          <Input autoFocus placeholder="LTV" />
        </Form.Item>
        <Form.Item name="preserve_as_is" valuePropName="checked">
          <Checkbox>Preserve as-is in all translations</Checkbox>
        </Form.Item>
        <Form.Item label="Notes (optional)" name="notes">
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
